import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  QueryList,
  Renderer2,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { BaseProductDetailComponent } from '@components/products/base-product-detail.component';
import {
  FundListingBRConfiguration,
  FundListingComponentType,
  FundListingDataFormat,
  FundListingFilterDropdown,
  FundListingState,
  SortingItems,
} from '@types';
import { Logger } from '@utils/logger';
import { Subject, Subscription } from 'rxjs';
import { FundListingDisplayComponent } from '../fund-listing-display-component.interface';
import { FundListingService } from '../services/fund-listing.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@components/shared/translate/translate.service';
import { Options } from 'ngx-slider-v2';
import { CommonService } from '@services/common.service';
import { WatchListService } from '../services/watch-list.service';
import { FundCompareService } from '../services/fund-compare.service';
import { EnvConfigService } from "@services/env-config.service";
import { AnalyticsService } from '@services/analytics.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

declare var bootstrap: any;

const logger = Logger.getLogger('FundListingComponent');

interface selectedOptions {
  selected: string;
  filter?: string;
}

@Component({
  selector: 'ft-fund-listing',
  templateUrl: './fund-listing.component.html',
  styleUrls: ['./fund-listing.component.scss'],
})
export class FundListingComponent
  extends BaseProductDetailComponent
  implements FundListingDisplayComponent, OnInit, OnDestroy, AfterViewInit {
  brConfiguration: FundListingBRConfiguration;
  dataSubscription: Subscription;
  componentType: FundListingComponentType;
  selectedComponentType: FundListingComponentType;
  fundListingState: FundListingState;
  fundListingData: FundListingDataFormat[] = [];
  isLoaded: boolean;
  type: string = ''

  // New Variables New Design
  showAdvanceFilter: boolean = false;
  showFilterBox: boolean = false;
  showSelected: boolean = false;
  selectedOptions: string[] = [];
  selectedOptionsCategory: selectedOptions[] = []
  sidebarFilterList: Array<any> = [];
  allfundsActive: boolean = false;
  optionst: Options = {
    floor: 0,
    ceil: 100,
    step: 25, // Set the step value to match the custom values
    showTicks: true, // Show tick marks
    getLegend: (value: number): string => {
      const mapping = this.customValueToLegendMapping?.find(item => item.value === value);
      return mapping ? mapping.legend : '';
    }
  };

  // Define the custom value-to-legend mapping
  customValueToLegendMapping = [
    {value: 0, legend: 'All'},
    {value: 25, legend: 'Low'},
    {value: 50, legend: 'Moderate'},
    {value: 75, legend: 'High'},
    {value: 100, legend: 'very High'}
  ];

  options: Options = {
    floor: 0,
    ceil: 20000,
    step: 100
  };
  options1: Options = {
    floor: 0,
    ceil: 100,
  };
  minReturn: number = 0;
  highReturn: number = 0;
  minRisk: number = 0;
  minSize: number = 0;
  highSize: number = 20000;
  minAge: number = 0;
  highAge: number = 100;
  isMobileView: boolean = false;
  lastKnownScrollPosition: any;
  deltaYr: number = 0;
  deltaYt: number = 0;
  sortItemsArray: SortingItems[] = [];
  selectedSortItem: SortingItems;
  watchListFundsCount: number = 0;
  compareListFundsCount: number = 0;
  fundTitle: string;
  accountsUrl: string;
  private analyticsTerms = new Subject<string>();
  private analyticsSubscription;
  @ViewChild('offcanvasBottomNew', {static: false}) offcanvasBottom!: ElementRef;
  @ViewChildren('filterButton') filterButtons!: QueryList<ElementRef>;

  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event: any) {
    const deltaY = window.scrollY - this.lastKnownScrollPosition;
    this.deltaYr = window.scrollY - this.lastKnownScrollPosition;
    this.lastKnownScrollPosition = window.scrollY;
    let menu: any = document.getElementById("header-top");
    let menu3: any = document.getElementById("header-top3");
    let accordionHeight: any = document.getElementById('filterAccordion');
    let mutualfundsticker = document.getElementById('mutualfundsheader');
    let winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    let height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    let scrolled = (winScroll / height) * 100;
    this.deltaYt = (winScroll / height) * 100;
    this.isMobileView = window.innerWidth < 768;
    if (deltaY > 0 && scrolled > 1.5) {
      if (window.innerWidth > 768) {
        mutualfundsticker?.classList.add('sidebar-position-stiky');
        mutualfundsticker?.classList.remove('d-none');
        accordionHeight?.classList.add('h-400');
      } else {
        menu?.classList.remove("position-stiky");
        menu?.classList.add("top-1");
        menu3.classList.remove("checkTop");
      }

    } else if (deltaY < 0 && scrolled < 1.5) {
      if (window.innerWidth > 768) {
        mutualfundsticker?.classList.remove('sidebar-position-stiky')
        accordionHeight?.classList.remove('h-400');
      } else {
        if (scrolled < 0.5) {
          menu?.classList.remove("position-stiky");
        }
        menu3.classList.remove("checkTop");
      }
    } else {
      if (window.innerWidth > 768) {
        mutualfundsticker?.classList.remove('sidebar-position-stiky');
      } else {
        setTimeout(() => {
          if (scrolled > 7) {
            menu?.classList.remove("top-1");
            menu.classList.add("position-stiky");
          }
        }, 100);
      }

    }
  }

  forCount: number;
  searchTerm: string = '';
  mobileFilterChips: string[] = [];
  preData: string[] = ['All'];
  selectedAnnualReturn: string | null = null;
  fullFundsArray: FundListingDataFormat[] = [];

  selectedFund: any = null;
  badgeValue: string;
  focusFunds: any = [];
  suitableForFilter: FundListingFilterDropdown[] = [];
  annalisedReturnsFilter: FundListingFilterDropdown[] = [];
  annalisedReturnsOptions = [
    {"label": "Since Inception", "value": "Since Inception", "selected": false},
    {"label": "1 Year", "value": "1 Year", "selected": false},
    {"label": "3 Years", "value": "3 Years", "selected": false},
    {"label": "5 Years", "value": "5 Years", "selected": false},
    {"label": "10 Years", "value": "10 Years", "selected": false},];
  filteredList: any;
  filterAdvanceFlag: boolean = false;
  navAlertsLink: string = '';
  showFundSearchDropdown: boolean = true;
  pageTitle: string = '';
  showMainList: boolean = false;

  @HostListener('click', ['$event'])
  getTableDataPage(event: Event) {
    const clickedElement = event.target as Element;
    if (clickedElement.classList.contains('funds-seach-title')) {
      this.showFundSearchDropdown = false;
    } else if (clickedElement.classList.contains('form-control')) {
      this.showFundSearchDropdown = true;
    } else if (!clickedElement.classList.contains('funds-seach-title')) {
      this.showFundSearchDropdown = false;
    }
  }

  fundsForSearch: FundListingDataFormat[] = [];
  showNav: boolean = true;

  constructor(
    private fundListingService: FundListingService,
    private translateService: TranslateService,
    private cdr: ChangeDetectorRef,
    private commonService: CommonService,
    private router: Router,
    private watchlistService: WatchListService,
    private compareService: FundCompareService,
    private envConfig: EnvConfigService,
    private route: ActivatedRoute,
    private analyticsService: AnalyticsService,
    private renderer: Renderer2
  ) {
    super();
  }

  ngOnInit(): void {
    this.accountsUrl = this.envConfig.getEnvConfig()?.ftiAccountsUrl;
    this.badgeValue = this.translateService.instant("products.focused-funds-badge");
    let focusFunds = this.translateService.instant("products.focused-funds-config");
    this.navAlertsLink = this.translateService.instant("products.nav-alerts-link");
    const focusFundsArray = focusFunds?.split(",");
    this.focusFunds = focusFundsArray?.map(number => {
      return {"fundId": number};
    });
    this.sortItemsArray = JSON.parse(this.translateService.instant("products.funds-sorting-list"));

    let suitableforArray = JSON.parse(this.translateService.instant("products.funds-suitable-for-list"));
    this.suitableForFilter.push({
      filterLabel: 'Suitable For',
      filterName: 'suitableFor',
      filterItems: suitableforArray,
    });

    this.annalisedReturnsFilter.push({
      filterLabel: 'Annualised Returns',
      filterName: 'annualisedReturns',
      filterItems: this.annalisedReturnsOptions,
    });

    if (this.sortItemsArray) {
      this.selectedSortItem = this.sortItemsArray?.find(item => item.default) || this.sortItemsArray[0];
    }
    this.watchlistService.watchlistCount$.subscribe((count) => {
      this.watchListFundsCount = count;
    });
    this.compareService.compareListCount$?.subscribe((count) => {
      this.compareListFundsCount = count;
    });

    this.route.queryParams.subscribe(params => {
      if (params.type === 'IDCW') {
        this.onComponentTypeChange("IDCW")
      }
    });
    this.analyticsSubscription = this.analyticsTerms.pipe(
      debounceTime(300), // wait 300ms after the last event before emitting last event
      distinctUntilChanged() // only emit if value is different from the previous value
    ).subscribe(term => this.setGoogleAnalytics(term));
  }


  /**
   * Initialized when current commponent gets loaded.
   * @param brConfiguration bloomreach configuration received
   */
  populate(brConfiguration: FundListingBRConfiguration): void {
    // Save BR configuration only once.
    if (!this.brConfiguration) {
      this.brConfiguration = brConfiguration;
    }
    // If component type is other than PPSS, then by default make it 'NAVs'.
    if (
      !this.selectedComponentType &&
      this.brConfiguration.config.componentType !==
      FundListingComponentType.PPSS
    ) {
      this.selectedComponentType = FundListingComponentType.NAV;
    }

    this.dataSubscription = this.fundListingService
      .getFundInformationState$()
      ?.subscribe(
        async (state) => {
          logger.debug('Mapped fund listing state: ', state);
          this.isLoaded = state.isLoaded;
          logger.debug("isLoaded::", this.isLoaded);
          if (this.isLoaded) {
            // Assign component type to be rendered.
            this.componentType = this.brConfiguration.config.componentType;

            // Assign received state for specific component type.
            this.fundListingState = state;
            let filters = state?.filterDropdowns;
            for (let list of filters) {
              list.filterItems.splice(0, 1);
            }
            filters.push(this.annalisedReturnsFilter[0]);
            filters.push(this.suitableForFilter[0]);
            this.sidebarFilterList = this.transformFiltersData(filters);
            this.filteredList = this.sidebarFilterList?.filter((e) => e.filterLabel == 'Annualised Returns');
            this.mobileFilterChips = this.sidebarFilterList[0].filterItems;
            this.fundTitle = this.translateService.instant("products.all-funds-display-tag");
            this.fundListingState?.ppssState && this.processPPSSData();
            this.fundListingState?.navState && this.processNAVData();
            this.fundListingState?.idcwState && this.processIDCWData();
          }

          this.cdr.detectChanges();
        },
        (error) => {
          logger.error('Error in invoking fund listing service: ', error);
          this.isLoaded = false;
          this.cdr.detectChanges();
        }
      );

    this.fundListingService.populate(this.brConfiguration);
  }

  processPPSSData() {
    if (this.fundListingState?.ppssState?.ppssPageTitle !== this.translateService.instant("products.ppss-page-title-all")) {
      this.selectedOptionsCategory.push({
        selected: this.fundListingState.ppssState.ppssPageTitle,
        filter: this.translateService.instant("products.ppss-filter-type-assetClass")
      });
      this.pageTitle = this.fundListingState.ppssState.ppssPageTitle;
      this.forCount = this.selectedOptionsCategory.length;
      this.selectedOptions.push(this.pageTitle);
      this.preData.push(this.pageTitle);
      this.fundTitleChange(this.selectedOptionsCategory, "");
      this.updateShowSelected();
    }
    let modifiedData = this.fundListingState?.ppssState?.ppssData ? JSON.parse(
      JSON.stringify(this.fundListingState?.ppssState?.ppssData)) : [];
    this.customizeFundData(modifiedData);
    this.fullFundsArray = this.fundListingState?.ppssState?.fullData ? JSON.parse(
      JSON.stringify(this.fundListingState?.ppssState?.fullData)) : [];
  }

  processNAVData() {
    let modifiedData = this.fundListingState?.navState?.navData ? JSON.parse(
      JSON.stringify(this.fundListingState?.navState?.navData)) : [];
    this.customizeFundData(modifiedData);
    this.fullFundsArray = this.fundListingState?.navState?.navData ? JSON.parse(
      JSON.stringify(this.fundListingState?.navState?.navData)) : [];
  }

  processIDCWData() {
    let modifiedData = this.fundListingState?.idcwState?.idcwData ? JSON.parse(
      JSON.stringify(this.fundListingState?.idcwState?.idcwData)) : [];
    this.customizeFundData(modifiedData);
    this.fullFundsArray = this.fundListingState?.idcwState?.idcwData ? JSON.parse(
      JSON.stringify(this.fundListingState?.idcwState?.idcwData)) : [];
  }

  mobileFilterBox() {
    this.showFilterBox = false;
    this.filterAdvanceFlag = true;
    this.preData = [];
    this.allFundsFilter();
    this.updateShowSelected();
  }

  customizeFundData(modifiedData): void {
    // Sort the array based on averageAnnualReturnSinceInception using the new method
    modifiedData = this.sortDataByAverageAnnualReturn(modifiedData);
    // Creating new Object selectedDropdown in each fund object so that in every fund card we have default dropdown Since Inception
    for (let i = 0; i < modifiedData.length; i++) {
      let selectedFund = modifiedData[i];
      // Find the object with value "averageAnnualReturnSinceInception" in ppssPeriodDropdownItems
      // Add selectedDropdown to the main object
      selectedFund.selectedDropdown = selectedFund.ppssPeriodDropdownItems?.find(item => item.value === "averageAnnualReturnSinceInception");
    }

    // Adding the Focus Badge.
    this.fundListingData = modifiedData.map(fund => {
      // Check if the fundId is in focusFunds array
      if (this.focusFunds.some(focusFund => focusFund.fundId === fund.fundId)) {
        // Add the badge property
        return {...fund, badge: this.badgeValue ? this.badgeValue : 'focus'};
      }
      return fund;
    });

    // Sort the array based on badge and prioritize funds with badge: focus
    this.fundListingData.sort((a, b) => {
      // Check if funds have the badge: focus property
      const aHasFocusBadge = a.badge === this.badgeValue;
      const bHasFocusBadge = b.badge === this.badgeValue;

      // Prioritize funds with the badge: focus property
      if (aHasFocusBadge && !bHasFocusBadge) {
        return -1;
      } else if (!aHasFocusBadge && bHasFocusBadge) {
        return 1;
      }

      // If both funds have the badge: focus property or neither does,
      // maintain the current order in the array
      return 0;
    });
  }

  ngOnDestroy(): void {
    // Clean up subscription to avoid memory leaks.
    this.dataSubscription?.unsubscribe();
    if (this.analyticsSubscription) {
      this.analyticsSubscription.unsubscribe();
    }
  }

  toggleAdvanceFilter() {
    this.showAdvanceFilter = !this.showAdvanceFilter;
    if (this.showAdvanceFilter) {
      this.allfundsActive = true;
      this.showMainList = true;
    } else {
      this.allfundsActive = false;
      this.showMainList = false;
    }
    this.sidebarFilterList.find((list) => {
      for (let defaultFilter of list.filterItems) {
        if (defaultFilter.selected) {
          defaultFilter.selected = false;
        }
      }
    })
    if (this.selectedOptions.length > 0 || this.selectedOptionsCategory.length > 0) {
      this.sidebarFilterList.find((option) => {
        for (const selectedCategory of this.selectedOptionsCategory) {
          if (option.filterLabel === selectedCategory.filter) {
            for (let checked of option.filterItems) {
              if (checked.label === selectedCategory.selected) {
                checked.selected = true;
              }
            }
          }
        }
      })
    }
    this.cdr.detectChanges();
    this.filterAdvanceFlag = true;
  }

  allFundsFilter() {
    this.fundsForSearch = this.fundListingData;
    this.searchTerm = '';
    if (this.showAdvanceFilter) {
      this.showMainList = false;
    }
    this.selectedOptions = this.selectedOptionsCategory.map(opt => opt.selected);
    this.fundTitleChange(this.selectedOptionsCategory, "");
    this.updateShowSelected();
    let assetOptions = [];
    let alternateOptions = [];
    let fundOptions = [];
    let tenureOptions = [];
    let annualisedReturnOptions = [];
    let suitableForOptions = [];
    let advanceFilter = [];
    this.fundListingData = this.fullFundsArray;
    this.customizeFundData(this.fundListingData);
    for (let option of this.selectedOptionsCategory) {
      switch (option.filter) {
        case this.translateService.instant("products.ppss-filter-type-assetClass"): {
          assetOptions.push(option.selected);
          break;
        }
        case this.translateService.instant("products.ppss-filter-type-alternativeFor"): {
          alternateOptions.push(option.selected);
          break;
        }
        case this.translateService.instant("products.ppss-filter-type-fundCategory"): {
          fundOptions.push(option.selected);
          break;
        }
        case this.translateService.instant("products.ppss-filter-type-investmentTenure"): {
          tenureOptions.push(option.selected)
          break;
        }
        case this.translateService.instant("products.ppss-card-annualized-returns"): {
          annualisedReturnOptions.push(option.selected)
          break;
        }
        case this.translateService.instant("products.overview-suitable-for"): {
          suitableForOptions.push(option.selected)
          break;
        }
      }
    }
    if (assetOptions.length > 0) {
      this.filterCategoryFunds(assetOptions, 1);
    }
    if (alternateOptions.length > 0) {
      this.filterCategoryFunds(alternateOptions, 2);
    }
    if (fundOptions.length > 0) {
      this.filterCategoryFunds(fundOptions, 3);
    }
    if (tenureOptions.length > 0) {
      this.filterCategoryFunds(tenureOptions, 4);
    }
    if (annualisedReturnOptions.length > 0) {
      this.filterCategoryFunds(annualisedReturnOptions, 5);
    }
    if (suitableForOptions.length > 0) {
      this.filterCategoryFunds(suitableForOptions, 6);
    }
    if (this.filterAdvanceFlag) {
      this.showAdvanceFilter = false;
      advanceFilter.push(this.optionst.getLegend(this.minRisk));
      if (this.minRisk > 0) {
        this.filterCategoryFunds(advanceFilter, 7);
      }
      if (this.minSize > 0 || this.highSize < 20000) {
        this.filterCategoryFunds(advanceFilter, 8);
      }
      if (this.minAge > 0 || this.highAge < 100) {
        this.filterCategoryFunds(advanceFilter, 9);
      }
    }
  }

  filterCategoryFunds(selectedList: string[], filter: number) {
    this.fundListingData = this.fundListingData.filter(fund => {
      for (let opt of selectedList) {
        switch (filter) {
          case 1: {
            if (fund.assetClass === opt) {
              return fund;
            }
            break;
          }
          case 2: {
            if (fund.alternateivefor.toLocaleLowerCase() === opt.toLocaleLowerCase()) {
              return fund;
            }
            break;
          }
          case 3: {
            if (fund.invfocus.toLocaleLowerCase() === opt.toLocaleLowerCase()) {
              return fund;
            }
            break;
          }
          case 4: {
            if (fund.invtenure.toLocaleLowerCase() === opt.toLocaleLowerCase()) {
              return fund;
            }
            break;
          }
          case 5: {
            for (let i = 0; i < fund.ppssPeriodDropdownItems.length; i++) {
              if (fund.ppssPeriodDropdownItems[i].label === opt &&
                parseFloat(fund.ppssPeriodDropdownItems[i].assetValue) < this.highReturn) {
                return fund;
              }
            }
            break;
          }
          case 6: {
            var array = fund.suitableFor.split(',')
            for (let i = 0; i < array.length; i++) {
              if (opt === array[i].trim()) {
                return fund;
              }
            }
            break;
          }
          case 7: {
            const risklevel = this.commonService.riskFromFundDoc(fund.productLabel);
            if (risklevel !== undefined && risklevel.toLowerCase() === opt.toLowerCase()) {
              return fund;
            }
            break;
          }
          case 8: {
            const fundSize: number = +fund.aum.totalNetAssets;
            if (fundSize > this.minSize && fundSize < this.highSize) {
              return fund;
            }
            break;
          }
          case 9: {
            if (fund.fundAge > this.minAge && fund.fundAge < this.highAge) {
              return fund;
            }
            break;
          }
        }
      }
    });
  }

  toggleShowFilterBox() {
    this.showFilterBox = !this.showFilterBox;
  }

  removeOption(option: string) {
    const index = this.selectedOptions.indexOf(option);
    if (index !== -1) {
      this.selectedOptions.splice(index, 1);
    }
    const indexofObj = this.selectedOptionsCategory?.findIndex((obj) => {
      return obj.selected === option;
    })
    if (indexofObj !== -1) {
      this.selectedOptionsCategory.splice(indexofObj, 1);
    }
    this.forCount = this.selectedOptionsCategory.length;
    // Uncheck the corresponding checkbox by ID
    const checkboxId = option.toString(); // Use the common ID for your checkboxes
    const checkbox = document.getElementById(checkboxId) as HTMLInputElement;
    if (checkbox) {
      checkbox.checked = false;
      if (checkboxId == 'Since Inception' || checkboxId == '1 Year' || checkboxId == '3 Years' || checkboxId == '5 Years' || checkboxId == '10 Years') {
        this.filteredList[0].showCustomReturn = false;
        this.highReturn = 0;
      }
    }
    this.allFundsFilter();
    this.fundTitleChange(this.selectedOptionsCategory, "");
    this.updateShowSelected();
    if (this.selectedOptions.length === 0) {
      this.pageTitle = '';
      this.allfundsActive = false;
    }
  }


  hideClear(selectedOptions: string[]) {
    this.allfundsActive = false;
    this.pageTitle = '';
    if (this.selectedOptionsCategory.length > 0 && selectedOptions.length == 0) {
      selectedOptions = this.selectedOptionsCategory.map(opt => opt.selected);
    }
    for (const option of selectedOptions) {
      const checkboxId = option.toString();
      const checkbox = document.getElementById(checkboxId) as HTMLInputElement;
      if (checkbox) {
        checkbox.checked = false;
      }
    }
    this.sidebarFilterList.find((option) => {
      for (const selectedCategory of this.selectedOptionsCategory) {
        if (option.filterLabel === selectedCategory.filter) {
          for (let checked of option.filterItems) {
            if (checked.label === selectedCategory.selected) {
              checked.selected = false;
            }
          }
        }
      }
    })

    // Clear all selected options and update showSelected
    this.selectedOptions = [];
    this.selectedOptionsCategory = [];
    this.forCount = this.selectedOptionsCategory.length;
    this.filteredList[0].showCustomReturn = false;
    this.highReturn = 0;
    this.allFundsFilter();
    this.fundTitleChange(this.selectedOptionsCategory, "");
    this.updateShowSelected();
  }

  updateShowSelected() {
    // Update the showSelected variable based on whether there are selected options
    this.showSelected = this.selectedOptionsCategory.length > 0;
  }

  getCheckboxValue(event: any, target: any) {
    const option = event.target.value;
    const checked = event.target.checked;
    if (target === 'Annualised Returns') {
      // If it's an "Annualised Returns" radio button
      if (checked) {
        // Check if a previous option was selected and remove it
        if (this.selectedAnnualReturn !== null) {
          const indexofObj = this.selectedOptionsCategory?.findIndex((obj) => {
            return obj.selected === this.selectedAnnualReturn;
          })
          if (indexofObj !== -1) {
            this.selectedOptionsCategory.splice(indexofObj, 1);
          }
        }
        this.selectedAnnualReturn = option; // Update the selected value
        this.selectedOptionsCategory.push({selected: option, filter: target});
        this.forCount = this.selectedOptionsCategory.length;
        const selectGAoptionsCategory = this.selectedOptionsCategory.slice(-1);
        const event = (this.selectedComponentType === "LatestNavs" || this.selectedComponentType === "IDCW") ? 'ft_dropdown_search' : 'ft_textBox_dropDown_search';
        this.analyticsService.trackEvent({
          ft_event: event,
          event: 'Event Fund Explorer',
          category: 'Fund Explorer',
          action: 'Search by filter',
          label: selectGAoptionsCategory[0].filter + '|' + selectGAoptionsCategory[0].selected,
        });
      }
    } else {
      // Get the value attribute of the checkbox 
      if (checked) {
        this.selectedOptionsCategory.push({selected: option, filter: target});
        this.forCount = this.selectedOptionsCategory.length;
      } else {
        const indexofObj = this.selectedOptionsCategory?.findIndex((obj) => {
          return obj.selected === option;
        })
        if (indexofObj !== -1) {
          this.selectedOptionsCategory.splice(indexofObj, 1);
          this.forCount = this.selectedOptionsCategory.length;
        }
      }
      const selectGAoptionsCategory = this.selectedOptionsCategory.slice(-1);
      const event = (this.selectedComponentType === "LatestNavs" || this.selectedComponentType === "IDCW") ? 'ft_dropdown_search' : 'ft_textBox_dropDown_search';
      this.analyticsService.trackEvent({
        ft_event: event,
        event: 'Event Fund Explorer',
        category: 'Fund Explorer',
        action: 'Search by filter',
        label: selectGAoptionsCategory[0].filter + '|' + selectGAoptionsCategory[0].selected,
      });
    }
  }

  fundTitleChange(category, view) {
    if (category.length === 1) {
      if (view == "mobile") {
        this.fundTitle = category[0];
      } else if (this.translateService.instant("products.ppss-filter-type-assetClass") == category[0].filter) {
        this.fundTitle = category[0].selected;
      } else {
        this.fundTitle = this.translateService.instant("products.all-funds-display-tag");
      }
    } else if (category.length > 1) {
      this.fundTitle = this.translateService.instant("products.all-funds-title-selected");
    } else {
      this.fundTitle = this.translateService.instant("products.all-funds-display-tag");
    }
  }

  sliderEvent() {
    document.getElementById('slider')?.click();
  }

  showSelectedFund(fund: any) {
    this.setGoogleAnalytics(fund?.fundName);
    this.showFundSearchDropdown = false;
    if (this.selectedOptionsCategory.length > 0) {
      this.hideClear(this.selectedOptions);
    }
    this.selectedFund = fund;
    this.searchTerm = this.selectedFund?.fundName;
    const fundsArray = [...this.fullFundsArray];
    const selectedFund = fundsArray.find(fund => fund.fundId === this.selectedFund.fundId);
    this.fundListingData = [selectedFund];
  }

  searchFunds(searchTerm: string) {
    if (searchTerm && searchTerm.length >= 3) {
      this.fundsForSearch = this.fullFundsArray;
      this.fundsForSearch = this.fundsForSearch.filter((fund: any) =>
        fund.fundName.toLowerCase().includes(searchTerm.toLowerCase())
      );
      this.trackSearchAnalytics(searchTerm); // Debounce analytics tracking
    } else {
      this.fundsForSearch = this.fullFundsArray;
    }
  }

  trackSearchAnalytics(searchTerm: string): void {
    this.analyticsTerms.next(searchTerm); // Emit the search term for analytics tracking
  }

  setGoogleAnalytics(searchTerm) {
    if (this.selectedComponentType === 'LatestNavs') {
      this.type = "NAV's"
    } else if (this.selectedComponentType === 'IDCW') {
      this.type = "Dividends"
    } else {
      this.type = "Funds"
    }
    this.analyticsService.trackEvent({
      ft_event: "ft_textBox_search",
      event: 'Event Fund Explorer',
      category: 'Fund Explorer',
      action: 'Search by text',
      label: this.type + ' |' + searchTerm,
    });
  }

  clearSearch() {
    this.fundlistingFilter('All');
    this.unselectFilter();
    this.fundListingData = this.fullFundsArray;
    this.customizeFundData(this.fundListingData);
    this.fundsForSearch = this.fundListingData;
    this.searchTerm = '';
    if (this.preData[0] !== 'All') {
      for (let item of this.preData) {
        this.toggleOptionSelection(item);
      }
    }
    for (const option of this.selectedOptions) {
      const checkboxId = option.toString();
      const checkbox = document.getElementById(checkboxId) as HTMLInputElement;
      if (checkbox) {
        checkbox.checked = false;
      }
    }
    this.selectedOptions = [];
    this.selectedOptionsCategory = [];
    this.forCount = this.selectedOptionsCategory.length;
    this.updateShowSelected();
    this.fundTitleChange(this.selectedOptionsCategory, "");
  }

  isOptionSelected(option: string): boolean {
    return this.preData.includes(option);
  }

  fundlistingFilter(selectedFund: string) {
    this.hideClear(this.selectedOptions);
    if (selectedFund) {
      this.fundListingData = this.fullFundsArray;
      this.fundTitle = this.translateService.instant("products.all-funds-display-tag");
      if (selectedFund !== 'All') {
        this.allfundsActive = true;
        this.fundListingData = this.fundListingData.filter(fund => fund.assetClass === selectedFund);
        this.fundTitle = selectedFund;
      }
      const event = (this.selectedComponentType === "LatestNavs" || this.selectedComponentType === "IDCW") ? 'ft_dropdown_search' : 'ft_textBox_dropDown_search';
      this.analyticsService.trackEvent({
        ft_event: event,
        event: 'Event Fund Explorer',
        category: 'Fund Explorer',
        action: 'Search by filter',
        label: 'Asset Category |' + selectedFund,
      });
      this.customizeFundData(this.fundListingData);
    }
  }

  toggleOptionSelection(option: string) {
    if (option === 'All') {
      this.preData = ['All'];
    } else {
      if (this.preData.includes('All')) {
        this.preData = this.preData.filter(item => item !== 'All');
      }
      if (this.preData.includes(option)) {
        this.preData = this.preData.filter(item => item !== option);
      } else {
        this.preData.push(option);
      }
    }
    this.preData.sort();
    this.fundListingData = this.fullFundsArray;
    if (this.preData.length > 0) {
      this.filterCategoryFunds(this.preData, 1);
      this.customizeFundData(this.fundListingData);
    } else {
      this.customizeFundData(this.fundListingData);
    }
    this.fundTitleChange(this.preData, "mobile");
    this.minRisk = 0;
    this.minSize = 0;
    this.highSize = 20000;
    this.minAge = 0;
    this.highAge = 100;

    if (this.selectedOptions.length > 0 || this.selectedOptionsCategory.length > 0) {
      for (const option of this.selectedOptions) {
        const checkboxId = option.toString();
        const checkbox = document.getElementById(checkboxId) as HTMLInputElement;
        if (checkbox) {
          checkbox.checked = false;
        }
      }
      this.selectedOptions = [];
      this.selectedOptionsCategory = [];
      this.forCount = this.selectedOptionsCategory.length;
      this.filteredList[0].showCustomReturn = false;
      this.highReturn = 0;
      this.updateShowSelected();
    }
    const event = (this.selectedComponentType === "LatestNavs" || this.selectedComponentType === "IDCW") ? 'ft_dropdown_search' : 'ft_textBox_dropDown_search';
    this.analyticsService.trackEvent({
      ft_event: event,
      event: 'Event Fund Explorer',
      category: 'Fund Explorer',
      action: 'Search by filter',
      label: 'Asset Category |' + option,
    });
  }

  transformFiltersData(data) {
    const transformedFilters = data.map((filter, index) => {
      const filterId = index + 1;
      return {
        id: filterId,
        filterLabel: filter.filterLabel,
        filterName: filter.filterName,
        filterItems: filter.filterItems.map((item, itemId) => ({
          id: itemId + 1,
          label: item.label,
          value: item.value,
          selected: item.selected
        }))
      };
    });
    return transformedFilters;
  }

  sortFunds(item: SortingItems): void {
    this.selectedSortItem = item;

    // Sort the fundListingData based on the selected criteria
    switch (item.id) {
      case 'popular':
        this.customizeFundData(this.fundListingData);
        break;

      case 'returnsHtoL':
        this.fundListingData = this.sortDataByAverageAnnualReturn(this.fundListingData);
        break;

      case 'fundSizeHtoL':
        this.fundListingData.sort((a, b) => {
          const sizeA = a.aum && a.aum.totalNetAssets ? parseFloat(a.aum.totalNetAssets) : -Infinity;
          const sizeB = b.aum && b.aum.totalNetAssets ? parseFloat(b.aum.totalNetAssets) : -Infinity;

          // Move funds with empty aum to the end
          if (!a.aum || Object.keys(a.aum).length === 0) {
            return 1; // Move a to the end
          }

          if (!b.aum || Object.keys(b.aum).length === 0) {
            return -1; // Move b to the end
          }

          return sizeB - sizeA;
        });
        break;

      case 'investorsHtoL':
        this.fundListingData.sort((a, b) => {
          const investorsA = parseInt(a.uniqueInvestors.replace(',', ''));
          const investorsB = parseInt(b.uniqueInvestors.replace(',', ''));
          return investorsB - investorsA;
        });
        break;

      // Add more cases for other sorting criteria if needed

      default:
        break;
    }
  }

  changeItem(item: SortingItems) {
    this.selectedSortItem = item;
  }

  removeOffCanvasOverflow() {
    this.dismissOffcanvas();
    this.renderer.setStyle(document.body, 'overflow', '');
    this.renderer.setStyle(document.body, 'padding-right', '');
  }

  applyFiter() {
    this.sortFunds(this.selectedSortItem);
    this.removeOffCanvasOverflow();
  }

  navigateToWatchlist() {
    let watchListUrl = this.translateService.instant("products.watch-list-url");
    this.router.navigate([watchListUrl]);
  }

  navigateCompareFunds() {
    let compareUrl = this.translateService.instant("products.fund-listing-compare-url");
    this.router.navigate([compareUrl]);
  }

  sortDataByAverageAnnualReturn(data: any[]): any[] {
    return data.sort((a, b) => {
      const returnA = parseFloat(a?.shareClassData?.performanceData?.averageAnnualReturnSinceInception);
      const returnB = parseFloat(b?.shareClassData?.performanceData?.averageAnnualReturnSinceInception);

      // Check if the parsed values are valid numbers
      const isValidNumberA = !isNaN(returnA);
      const isValidNumberB = !isNaN(returnB);

      // Handle cases where either or both values are not valid numbers
      if (isValidNumberA && isValidNumberB) {
        // Sort based on valid numeric values
        return returnB - returnA;
      } else if (isValidNumberA && !isValidNumberB) {
        // Sort valid numbers before non-valid numbers
        return -1;
      } else if (!isValidNumberA && isValidNumberB) {
        // Sort valid numbers before non-valid numbers
        return 1;
      } else {
        // Maintain the current order if neither value is a valid number
        return 0;
      }
    });
  }

  /**
   * Trigger actions when component type is changed.
   * @param selectedComponentType component type selected by user - NAVs/IDCW
   */
  onComponentTypeChange(selectedComponentType: string): void {
    this.selectedComponentType = selectedComponentType as FundListingComponentType;
    this.brConfiguration.config.componentType = this.selectedComponentType;
    this.fundListingService.populate(this.brConfiguration, true);
    this.showNav = (selectedComponentType === "LatestNavs");
    this.cdr.detectChanges();
  }

  removeFundString(value: string) {
    value = value.replace(/funds|fund/gi, "");
    return value;
  }

  changeFilter(data: string) {
    const event = (this.selectedComponentType === "LatestNavs" || this.selectedComponentType === "IDCW") ? 'ft_dropdown_search' : 'ft_textBox_dropDown_search';
    this.analyticsService.trackEvent({
      ft_event: event,
      event: 'Event Fund Explorer',
      category: 'Fund Explorer',
      action: 'Search by filter',
      label: data,
    });
  }

  ngAfterViewInit(): void {
    const offcanvasElement = this.offcanvasBottom.nativeElement;
    offcanvasElement.addEventListener('hidden.bs.offcanvas', this.removeBackdrop);
  }

  dismissOffcanvas(): void {
    const offcanvasElement = this.offcanvasBottom.nativeElement;
    const offcanvas = new bootstrap.Offcanvas(offcanvasElement);
    offcanvas.hide();
  }

  private removeBackdrop(): void {
    const backdrop = document.querySelector('.offcanvas-backdrop');
    if (backdrop) {
      backdrop.parentNode?.removeChild(backdrop);
    }
  }

  unselectFilter() {
    this.filterButtons.forEach(button => {
      const nativeElement = button.nativeElement;
      if (nativeElement.getAttribute('aria-selected') === 'true') {
        this.renderer.setAttribute(button.nativeElement, 'aria-selected', 'false');
        this.renderer.removeClass(button.nativeElement, 'active');
      }
    });
  }

}
